import { useQuery } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import API from '../utils/axios/API';
import taquitoCatchRequest from '../utils/taquitoCatchRequest';
import adminSelector from '../redux/selectors/adminSelector';

const useGetRequest = (queryKey, baseUrl, params = {}, enabled = true, showErrorMessage = true) => {
  const { token } = useSelector(adminSelector);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return useQuery({
    refetchOnWindowFocus: false,
    queryKey,
    queryFn: async () => {
      const queryParams = new URLSearchParams(params);
      const url = `${baseUrl}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      let data = {};
      try {
        const { data: fetchData } = await API.get(url, { headers: { Authorization: token } });
        data = fetchData;
      } catch (error) {
        if (showErrorMessage) taquitoCatchRequest(error, dispatch, navigate);
        throw error;
      }

      return data?.result;
    },
    enabled,
  });
};

export default useGetRequest;
